// Отображаемые категории на /training и home-карточке «Тренировки». Виды вне
// этого списка (WHOOP-бакет `activity`, пейнтбол, рыбалка, cycling и любой
// новый) сводятся в «Другое» через fallback в sportLabel/sportEmoji.
//
// Присутствие вида здесь — это только ЯРЛЫК, не признак тренировки. Что
// считается полноценной тренировкой, решает `REAL_WORKOUT_EXCLUDED_SPORTS` в
// backend/app/integrations/whoop.py, и списки намеренно расходятся: `sauna`
// названа своим именем, но остаётся исключённой из `payload.real` — при
// включённом по умолчанию тоггле «Только полноценные» её строки нет вовсе.
const SPORT_MAP: Record<string, { label: string; emoji: string | null }> = {
  weightlifting:      { label: 'Силовая',        emoji: '🏋️' },
  elliptical:         { label: 'Эллипс',         emoji: '🌀' },
  assault_bike:       { label: 'Велотренажер',   emoji: '🚴' },
  functional_fitness: { label: 'Функциональная', emoji: '🤸' },
  walking:            { label: 'Ходьба',         emoji: '🚶' },
  hiking:             { label: 'Хайкинг',        emoji: '🥾' },
  hiking_rucking:     { label: 'Хайкинг',        emoji: '🥾' },
  stretching:         { label: 'Растяжка',       emoji: '🧘' },
  soccer:             { label: 'Футбол',         emoji: '⚽' },
  paddle_tennis:      { label: 'Падел / Теннис', emoji: '🎾' },
  padel:              { label: 'Падел / Теннис', emoji: '🎾' },
  tennis:             { label: 'Падел / Теннис', emoji: '🎾' },
  yoga:               { label: 'Йога',           emoji: '🪷' },
  running:            { label: 'Бег',            emoji: '🏃' },
  // WHOOP не отдаёт по сауне ни strain, ни пульс (0 из 9 записей за 4 месяца) —
  // отсюда strain «—» в её строке «По типу», и отсюда же она в
  // REAL_WORKOUT_EXCLUDED_SPORTS: не потому, что нагрузки нет, а потому, что
  // измерить её нечем.
  sauna:              { label: 'Сауна',          emoji: '🧖' },
};

// WHOOP API возвращает sport_name с дефисами («functional-fitness»),
// SPORT_MAP индексирован по подчёркиванию — нормализуем.
function normalize(code: string | null | undefined): string | null {
  if (!code) return null;
  return code.replace(/-/g, '_').toLowerCase();
}

export function sportLabel(code: string | null | undefined): string {
  const key = normalize(code);
  if (!key) return 'Другое';
  return SPORT_MAP[key]?.label ?? 'Другое';
}

export function sportEmoji(code: string | null | undefined): string {
  const key = normalize(code);
  // Fallback 🤾 = «Другое» — distinct from 🤸 (Функциональная).
  if (!key) return '🤾';
  return SPORT_MAP[key]?.emoji ?? '🤾';
}
